import { useCallback, useEffect, useState } from 'react';
import { Flex } from 'antd';

import {
  useAppSelector,
  useRequestTypeFinderById,
  useStatusFinderByNum,
} from '@Hooks/index';
import {
  useDownloadDocumentQuery,
  useFormListMutation,
} from '@Store/api/dmsApiSlice';
import { useGetHrmRequestFormQuery } from '@Store/api/basicHrmApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { getDocument } from '@Features/utils/document';
import { useGetUsersListByNameQuery } from '@Store/api/userApiSlice';
import { useGetEmpPhotoQuery } from '@Store/api/dictionaryApiSlice';

import fieldSource from './FieldSource';
import styles from './view-form.module.css';
import { getDocumentFolder } from '../utils/document';

const RequestViewForm: React.FC = () => {
  const { findStatus } = useStatusFinderByNum('Leave');
  const { findRequestType } = useRequestTypeFinderById('Leave');
  const requestId = useAppSelector(getModalRecordKey);
  const { data } = useGetHrmRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });
  const { data: users = [] } = useGetUsersListByNameQuery(null);
  const [getFormList] = useFormListMutation();

  const [documentId, setDocumentId] = useState('');

  const { data: imageURL } = useDownloadDocumentQuery(documentId || '', {
    skip: !documentId,
  });

  const replacementUser = users.find(
    (item) => item.empNumber === data?.replacementEmpNo
  );

  const { data: userPhoto } = useGetEmpPhotoQuery(
    replacementUser?.empImageName || ''
  );

  useEffect(() => {
    setDocumentId('');
    if (!data?.requestId || !data?.filepath) {
      return;
    }

    const documentFolderPath = getDocumentFolder(data.requestId);

    getFormList(documentFolderPath)
      .unwrap()
      .then((response) => {
        const matchedDocument = getDocument(response, data.filepath);

        if (matchedDocument) {
          setDocumentId(matchedDocument.documentId);
        }
      });
  }, [data]);

  const handleDownloadClick = useCallback((): void => {
    if (imageURL && data?.filepath) {
      const a = document.createElement('a');
      a.href = imageURL;
      a.download = data.filepath;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  }, [imageURL, data?.filepath]);

  if (!data) return null;

  return (
    <Flex className={styles.viewForm} vertical>
      {fieldSource(
        data,
        findRequestType,
        findStatus,
        documentId,
        users,
        userPhoto,
        replacementUser,
        handleDownloadClick
      ).map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          <span className={styles.viewItemValue}>{item.value}</span>
        </div>
      ))}
    </Flex>
  );
};

export default RequestViewForm;
